import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, applyTransform } from "@project-rouge/rg-three";
import { getObjsDir } from "./index155.js";
import { sort2dObjsbyVector } from "./index158.js";
function getSortedModules(apartmentArray, apartmentIndex) {
  const apartment = apartmentArray[apartmentIndex];
  const modules = apartment.children.filter((ch) => ch.type === RG_TYPE.Module);
  if (apartmentArray.length > 1) {
    const direction3d = getObjsDir(apartmentArray[0], apartmentArray[apartmentArray.length - 1]);
    const direction = [direction3d[0], direction3d[2]];
    return sort2dObjsbyVector(modules, direction, (x) => Vector3toV3(applyTransform(x, apartment)));
  } else {
    return sort2dObjsbyVector(modules, [1, 0]);
  }
}
export {
  getSortedModules
};
//# sourceMappingURL=index156.js.map
